import {
  Box,
  Button,
  Chip,
  Divider,
  Menu,
  MenuItem,
  Skeleton,
  Tab,
  Tabs,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import {
  cancelSubscriptionAction,
  getUserProfileAction,
} from "../../redux/actions";
import { AppDispatch } from "../../store/store";
import { useDispatch, useSelector } from "react-redux";
import AddCreditModal from "../Modals/AddCreditModal";
import { setIsAddCreditModalOpen } from "../../store/slices/MRSlice";
import { menuItemSX } from "../Builder/BuilderConst";
import { useNavigate } from "react-router-dom";
import { routes } from "../../utils/routes";
import ConfirmationMsgModal from "../Modals/ConfirmationMsgModal";
// import Invoice from "./Invoice"; // commented — replaced by BillingInvoice
import BillingInvoice from "./BillingInvoice";
import MaterialIcons from "../../assests/MaterialIcons/MaterialIcons";
import { billingCustomerPortalAction } from "../../redux/actions/UserActions/BillingActions";
import SubscriptionTab from "./SubscriptionTab";

const typographyStyle = {
  fontFamily: "var(--font-family-manrope)",
  fontWeight: 400,
  fontSize: "16px",
};

const formatDate = (date: string | Date) => {
  if (!date) return "";
  return new Date(date).toLocaleDateString("en-US", {
    month: "short",
    day: "2-digit",
    year: "numeric",
  });
};

const formatLongDate = (date: string | Date) => {
  if (!date) return "";
  return new Date(date).toLocaleDateString("en-US", {
    month: "long",
    day: "2-digit",
    year: "numeric",
  });
};

/*
const PlanTab = ({
  data,
  dashboardDataLoading,
}: {
  data: any;
  dashboardDataLoading: any;
}) => {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();

  const [openConfimationMsgModal, setOpenConfimationMsgModal] = useState(false);

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const openMenu = Boolean(anchorEl);

  const handleMenuOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleCancelPlanData = async () => {
    const payload = {
      id: data?.membershipdata?.subscriptionId,
    };
    await dispatch(cancelSubscriptionAction(payload));
    await dispatch(getUserProfileAction());
    setOpenConfimationMsgModal(false);
  };

  const handleCustomerPortalData = async () => {
    dispatch(billingCustomerPortalAction())
      .unwrap()
      .then((res) => {
        const url = res?.data?.url;
        if (url) {
          window.open(url, "_blank", "noopener,noreferrer");
        }
      })
      .catch((err) => console.error(err));
  };

  if (dashboardDataLoading) {
    return (
      <Box sx={{ maxWidth: "1200px", marginBottom: "10px" }}>
        <Box
          sx={{
            p: 3,
            backgroundColor: "#FFF",
            borderRadius: "var(--medium-large-border-radius)",
            border: "1px solid #e5e7eb",
          }}
        >
          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <Box>
              <Skeleton width={180} height={28} />
              <Skeleton width={240} height={18} sx={{ mt: 1 }} />
              <Skeleton width={120} height={44} sx={{ mt: 2 }} />
            </Box>
            <Skeleton width={120} height={36} />
          </Box>

          <Divider sx={{ my: 3 }} />

          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <Box>
              <Skeleton width={180} height={22} />
              <Skeleton width={360} height={18} sx={{ mt: 1 }} />
            </Box>
            <Skeleton width={120} height={36} />
          </Box>
        </Box>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        maxWidth: "1200px",
        marginBottom: "10px",
      }}
    >
      <Box
        sx={{
          p: 3,
          backgroundColor: "#FFF",
          borderRadius: "var(--medium-large-border-radius)",
          border: "1px solid #e5e7eb",
        }}
      >
        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <Box>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Typography
                sx={{ ...typographyStyle, fontWeight: 600, fontSize: "18px" }}
              >
                {data?.membership?.planName}
              </Typography>
              <Chip
                label={data?.membership?.type}
                size="small"
                sx={{
                  fontWeight: 500,
                  backgroundColor: "#dcfce7",
                  color: "#227447",
                }}
              />
            </Box>

            <Typography
              sx={{
                ...typographyStyle,
                color: "#6B7280",
                marginTop: "6px",
                fontSize: "14px",
              }}
            >
              {data?.membership?.cancelAtPeriodEnd ? "Cancelled" : "Renews"} on{" "}
              {formatLongDate(data?.membership?.nextBillingDate)}
            </Typography>

            <Typography
              sx={{
                fontSize: "36px",
                display: "flex",
                alignItems: "baseline",
                gap: "5px",
                mt: "12px",
              }}
            >
              ${data?.membership?.planPrice}
              <Typography
                component="span"
                sx={{
                  fontSize: "14px",
                  fontWeight: "400",
                  color: "#6B7280",
                }}
              >
                /{data?.membership?.type === "monthly" ? "mo" : "yr"}
              </Typography>
            </Typography>
          </Box>

          <Box>
            {data?.membership?.status === "inactive" ? (
              <Button
                onClick={() => navigate(routes?.upgrade)}
                sx={{
                  background: "#fff",
                  border: "1px solid #d1d5db",
                  textTransform: "none",
                  fontWeight: 400,
                  fontFamily: "var(--font-family-manrope)",
                  padding: "8px 14px",
                  color: "#000000",
                  borderRadius: "var(--large-border-radius)",
                  boxShadow: "none",

                  "&:hover": {
                    backgroundColor: "#f9fafb",
                    boxShadow: "none",
                  },
                }}
              >
                Upgrade plan
              </Button>
            ) : (
              <>
                <Button
                  onClick={handleMenuOpen}
                  sx={{
                    background: "#fff",
                    border: "1px solid #d1d5db",
                    textTransform: "none",
                    fontWeight: 400,
                    fontFamily: "var(--font-family-manrope)",
                    padding: "8px 14px",
                    color: "#000000",
                    borderRadius: "var(--large-border-radius)",
                    boxShadow: "none",

                    "&:hover": {
                      backgroundColor: "#f9fafb",
                      boxShadow: "none",
                    },
                  }}
                >
                  Manage plan
                  <MaterialIcons.ArrowDropDown style={{ width: "20px" }} />
                </Button>

                <Menu
                  anchorEl={anchorEl}
                  open={openMenu}
                  onClose={handleMenuClose}
                  MenuListProps={{ dense: true }}
                  PaperProps={{
                    sx: {
                      mt: 1,
                      borderRadius: "12px",
                      minWidth: 160,
                      border: "1px solid #e5e7eb",
                      boxShadow: "0px 4px 12px rgba(0,0,0,0.08)",
                      padding: "2px 0",
                    },
                  }}
                >
                  <MenuItem
                    sx={menuItemSX}
                    onClick={() => {
                      handleMenuClose();
                      navigate(routes?.upgrade);
                    }}
                  >
                    <MaterialIcons.TrendingChart
                      style={{ width: "18px", marginRight: "10px" }}
                    />
                    Upgrade plan
                  </MenuItem>
                  <MenuItem
                    sx={menuItemSX}
                    onClick={() => {
                      handleCustomerPortalData();
                    }}
                  >
                    <MaterialIcons.CreditCard
                      style={{ width: "18px", marginRight: "10px" }}
                    />
                    Payment Method
                  </MenuItem>

                  <Divider />

                  <MenuItem
                    sx={{
                      py: "6px !important",
                      px: "12px !important",
                      mx: "4px !important",
                      my: "2px !important",
                      borderRadius: "var(--small-border-radius) !important",
                      color: "red !important",
                      fontWeight: "400 !important",
                      fontSize: "14px !important",
                      fontFamily: "var(--font-family-manrope)",

                      "&:hover": {
                        backgroundColor: "#fceced !important",
                        borderRadius: "var(--small-border-radius)",
                      },

                      "&.Mui-selected": {
                        backgroundColor: "#fceced !important",
                        borderRadius: "var(--small-border-radius)",
                      },

                      "&.Mui-focusVisible": {
                        backgroundColor: "#fceced !important",
                      },

                      "&.Mui-disabled": {
                        backgroundColor: "#fceced !important",
                        color: "red !important",
                        opacity: 0.7,
                        borderRadius: "var(--small-border-radius)",
                      },
                    }}
                    onClick={() => {
                      handleMenuClose();
                      setOpenConfimationMsgModal(true);
                    }}
                    disabled={data?.membership?.cancelAtPeriodEnd}
                  >
                    <MaterialIcons.Close
                      style={{ width: "18px", marginRight: "10px" }}
                    />
                    Cancel plan
                  </MenuItem>
                </Menu>
              </>
            )}
          </Box>
        </Box>

        <Divider sx={{ my: 3, border: "1px solid #e5e7eb" }} />

        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Box>
            <Typography
              sx={{ ...typographyStyle, fontWeight: 600, fontSize: "18px" }}
            >
              Add more scan credits
            </Typography>

            <Typography
              color="textSecondary"
              sx={{
                ...typographyStyle,
                color: "#6B7280",
                marginTop: "6px",
                fontSize: "14px",
              }}
            >
              Add credits to continue using the platform beyond your plan
              limits.
            </Typography>
          </Box>

          <Button
            sx={{
              background: "#fff",
              border: "1px solid #d1d5db",
              textTransform: "none",
              fontWeight: 400,
              fontFamily: "var(--font-family-manrope)",
              padding: "8px 14px",
              color: "#000000",
              borderRadius: "var(--large-border-radius)",

              "&:hover": {
                backgroundColor: "#f9fafb",
              },
            }}
            onClick={() => dispatch(setIsAddCreditModalOpen(true))}
          >
            Add credits
          </Button>
        </Box>
      </Box>

      <AddCreditModal />

      <ConfirmationMsgModal
        open={openConfimationMsgModal}
        handleClose={() => setOpenConfimationMsgModal(false)}
        onConfirm={handleCancelPlanData}
        title="Cancel Plan"
        isCancel={true}
        msg="Are you sure want to cancel this plan?"
      />
    </Box>
  );
};
*/

/* const InvoicesTab = () => {
  return (
    <Box
      sx={{
        maxWidth: "1000px",
        marginBottom: "10px",
      }}
    >
      <Invoice />
    </Box>
  );
}; */

const Billing = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { dashboardData, loading } = useSelector(
    (state: any) => state?.dashboard,
  );

  const [value, setValue] = useState<number>(0);

  useEffect(() => {
    dispatch(getUserProfileAction());
  }, []);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <Box
      sx={{
        width: "100%",
        minHeight: "100vh",
        px: { xs: 1.2, sm: 2.5, md: 5 },
        pt: 5,
      }}
    >
      {/* title conatiner */}
      {/* {loading ? (
        <Box sx={{ mb: 2 }}>
          <Skeleton width={140} height={42} />
          <Skeleton width={360} height={20} sx={{ mt: 1 }} />
        </Box>
      ) : ( */}
      <Box sx={{ mb: 2 }}>
        <Typography
          sx={{
            ...typographyStyle,
            fontFamily: "var(--font-family-rubik)",
            fontSize: "32px",
            fontWeight: 600,
            color: "#000000",
            letterSpacing: "0.00938em",
          }}
        >
          Billing
        </Typography>

        <Typography color="textSecondary" sx={{ ...typographyStyle }}>
          {/* Current cycle: {formatDate(dashboardData?.membership?.purchaseDate)}{" "}
            – {formatDate(dashboardData?.membership?.expiryDate)}{" "} */}
          Manage your subscriptions, view invoices, and payment details.
        </Typography>
      </Box>
      {/* )} */}

      {/* tabs */}
      <Tabs
        value={value}
        onChange={handleChange}
        variant="scrollable"
        scrollButtons={false}
        aria-label="settings tabs"
        sx={{ borderBottom: 1, borderColor: "divider" }}
      >
        {/* <Tab
          label="Plan"
          sx={{
            fontFamily: " var(--font-family-manrope)",
            fontSize: 15,
            fontWeight: 500,
            color: "#374151",
            transition: "color 0.25s ease",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            py: 0.6,
            textTransform: "capitalize",
          }}
        /> */}
        <Tab
          label="Subscription"
          sx={{
            fontFamily: " var(--font-family-manrope)",
            fontSize: 15,
            fontWeight: 500,
            color: "#374151",
            transition: "color 0.25s ease",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            py: 0.6,
            textTransform: "capitalize",
          }}
        />
        <Tab
          label="Invoices"
          sx={{
            fontFamily: "var(--font-family-manrope)",
            fontSize: 15,
            fontWeight: 500,
            color: "#374151",
            transition: "color 0.25s ease",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            py: 0.6,
            textTransform: "capitalize",
          }}
        />
      </Tabs>

      <Box
        sx={{
          mt: 3.5,
          mx: 0,
        }}
      >
        {/* {value === 0 && (
          <PlanTab data={dashboardData} dashboardDataLoading={loading} />
        )} */}
        {value === 0 && (
          <SubscriptionTab
            data={dashboardData}
            dashboardDataLoading={loading}
          />
        )}
        {value === 1 && <BillingInvoice />}
      </Box>
    </Box>
  );
};

export default Billing;
